import { STEP_REGISTRATION_ACTION_TYPES } from 'store/actions/step-registration.actions';

const initialState = {
  isFormProcessed: false,
  skipStep: {
    status: false,
    nextRoute: '',
    generalApiEndpoint: '',
  },
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_PREVIOUS_FORM_DATA:
      return { ...state, [payload.formsName]: payload.data };

    case STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SET_NULL_INITIAL_OBJECTS:
      const config = payload;
      const currentFormsState = state[config.formsName] || {};
      const newFormsState = { ...currentFormsState };
      let isKeyExcluded;
      for (let key in newFormsState) {
        isKeyExcluded = config.excludeObjectNames.find(
          (excludeObjectName) => excludeObjectName === key,
        );
        if (!isKeyExcluded && newFormsState.hasOwnProperty(key)) {
          newFormsState[key] = null;
        }
      }
      return {
        ...state,
        [config.formsName]: { ...newFormsState, isReinitialized: true },
      };

    case STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_CHANGE_PROCESSING:
      return { ...state, isFormProcessed: payload };

    case STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_SKIP:
      return { ...state, skipStep: { ...payload } };

    case STEP_REGISTRATION_ACTION_TYPES.STEP_REGISTRATION_CLEAR_SKIP:
      return { ...state, skipStep: { ...payload } };

    default:
      return state;
  }
}
